import React from 'react';
import './CastingMenuPage.css';
import angelImage from './Logo/Angel_1.png';


function CastingMenuPage({ onNavigate }) {
  return (
    <div className="casting-menu-container">
      <div className="casting-menu-card">
        <div className="casting-menu-header">
          <h2>Casting Call</h2>
          <p>Choose your category to begin the application process</p>
        </div>

        <div className="casting-options">
          <div className="casting-option-card">
  <div className="option-icon">⚖️</div>
  <h3>LEGAL PROFESSIONALS</h3>
  <p>Law degree required. Licensed in New York (NY) and/or Florida (FL). Both preferred.</p>
  <button
    className="btn-option"
    onClick={() => onNavigate('casting-law')}
  >
    Apply Now
  </button>
</div>
          <div className="casting-option-card">
<div className="option-icon">
  <img src={angelImage} alt="Olympic Angels" className="option-icon-image" />
</div>
            <h3>OLYMPIC ANGELS by Theo</h3>
            <p>Apply to become an Olympic Angel and join our exclusive projects</p>
            <button 
              className="btn-option"
              onClick={() => onNavigate('casting-models')}
            >
              Apply Now
            </button>
          </div>
          <div className="casting-option-card">
          <div className="option-icon">🎨</div>
          <h3>DESIGNERS · STYLISTS · PHOTOGRAPHERS</h3>
          <p>Apply for creative team opportunities</p>
            <button 
              className="btn-option"
              onClick={() => onNavigate('casting-designers')}
            >
              Apply Now
            </button>
          </div>
        </div>

        <div className="casting-menu-footer">
          <button 
            className="btn-back"
            onClick={() => onNavigate('home')}
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}


export default CastingMenuPage;
